import styled from "styled-components";

export const DividerContainer = styled.div`
	display: flex;
	height: 1px;
	background: #e4e4e4;
	width: 100%;
	margin: 20px 0 34px;
`;
